import { render, staticRenderFns } from "./ReportePeso.vue?vue&type=template&id=2347bdfa"
import script from "./ReportePeso.vue?vue&type=script&lang=js"
export * from "./ReportePeso.vue?vue&type=script&lang=js"
import style0 from "./ReportePeso.vue?vue&type=style&index=0&id=2347bdfa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports